import React, { useRef, useEffect } from 'react';

/**
 * Input con autocompletado de Google Places
 * Requiere que Google Maps API esté cargada
 */
const GooglePlacesInput = ({ value, onChange, onPlaceSelected, placeholder = "Escribe la dirección...", className = "" }) => {
    const inputRef = useRef(null);
    const autocompleteRef = useRef(null);

    useEffect(() => {
        // Verificar si Google Maps está disponible
        if (!window.google || !window.google.maps) {
            console.error('Google Maps API no está cargada');
            return;
        }

        if (inputRef.current && !autocompleteRef.current) {
            // Inicializar Autocomplete
            autocompleteRef.current = new window.google.maps.places.Autocomplete(
                inputRef.current,
                {
                    componentRestrictions: { country: 'co' }, // Solo Colombia
                    fields: ['formatted_address', 'geometry', 'name', 'place_id']
                }
            );

            // Listener para cuando se selecciona un lugar
            autocompleteRef.current.addListener('place_changed', () => {
                const place = autocompleteRef.current.getPlace();

                if (!place || !place.geometry) {
                    console.warn('No se pudo obtener la geometría del lugar');
                    return;
                }

                const addressData = {
                    address: place.formatted_address || place.name,
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng(),
                    place_id: place.place_id
                };

                if (onPlaceSelected) {
                    onPlaceSelected(addressData);
                }
            });
        }

        return () => {
            // Cleanup
            if (autocompleteRef.current) {
                window.google.maps.event.clearInstanceListeners(autocompleteRef.current);
            }
        };
    }, [onPlaceSelected]);

    return (
        <input
            ref={inputRef}
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            className={className || "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"}
            autoComplete="off"
        />
    );
};

export default GooglePlacesInput;
